<template>
  <div id="userTpl">
    <bio-top-bar></bio-top-bar>
    <div style="background-color:#f5f5f5">
      <router-view></router-view>
    </div>

    <div id="footer">
      <div class="soild"></div>
      <div class="soild1"></div>
      <div class="container">
        <el-row style="color: #999;margin-bottom: 30px" :gutter="60">
          <el-col :span="6">
            <div class="title">客户服务</div>
            <div class="info">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="lv3Text" target="_blank">
                    <div class="box hvr-fade">
                      <img
                        width="86px"
                        height="86px;"
                        :src="serve + '/webInfo/official_wx.jpg'"
                        alt
                      />
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <router-link to="/feedback">
                    <div class="box hvr-fade lv3Text">
                      <div class="ico">
                        <!-- <i class="fas fa-question-circle fa-lg"></i> -->
                        <i class="el-icon-question" style="font-size:34px"></i>
                      </div>
                      <div class="label">问题反馈</div>
                    </div>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">关注我们</div>
            <div class="info">
              <el-row>
                <el-col :span="12">
                  <el-popover placement="bottom-end" trigger="hover">
                    <div>
                      <img
                        class="qr"
                        :src="serve+src"
                        style="width:150px;height:150px"
                      />
                    </div>
                    <div slot="reference" class="box hvr-fade">
                      <img
                        class="qr"
                        :src="serve+src"
                        style="width:88px;height:88px"
                      />
                    </div>
                  </el-popover>
                </el-col>
                <el-col :span="12">
                  <a href="https://weibo.com/aogmayeli" target="_blank" class="lv3Text">
                    <div class="box hvr-fade">
                      <div class="ico">
                        <!-- <i class="fab fa-weibo fa-lg"></i> -->
                        <i class="iconfont icon-weibo" style="font-size:32px"></i>
                      </div>
                      <div class="label">微博</div>
                    </div>
                  </a>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">
              <router-link to="/brands" class="lv3Text brands">友情链接</router-link>
            </div>
            <div class="info">
              <span v-for="(item,index) of footer.data" :key="index">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  <el-link style="margin:3px 5px;">{{item.name}}</el-link>
                </a>
                <el-divider direction="vertical"></el-divider>
              </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">服务热线</div>
            <div class="phone">
              <span class="ico">
                <!-- <i class="fas fa-phone fa-lg fa-flip-horizontal"></i> -->
                <i class="el-icon-phone" style="font-size:34px"></i>
              </span>
              <span class="number">021-64179406</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="footer2" style="background-color: #EAEAEA;font-size: 12px;">
        <div class="container">
          <div class="top clearfix">
            <div class="first">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/1.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="label">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/2.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="label">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/3.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="end">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/4.png'"
                fit="cover"
              ></el-image>
            </div>
          </div>

          <div class="link1">
            <div class="list clearfix">
              <div>
                <ul>
                  <li>
                    <h3>新手入门</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/1_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >购物指南</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/1_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >交易条款</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/2_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >常见问题</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/11"
                      target="_blank"
                      rel="noopener noreferrer"
                    >联系客服</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>配送说明</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >上门自提</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >一日达</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >商品验收</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >配送服务查询</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>支付方式</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >账期支付</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >在线支付</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >公司转账</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/5_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >发票制度</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>售后服务</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >售后政策</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退款说明</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退换货政策</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退换货流程</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>帮助中心</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/register"
                      target="_blank"
                      rel="noopener noreferrer"
                    >用户注册</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/forget"
                      target="_blank"
                      rel="noopener noreferrer"
                    >找回密码</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/9"
                      target="_blank"
                      rel="noopener noreferrer"
                    >公司介绍</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/12"
                      target="_blank"
                      rel="noopener noreferrer"
                    >合作伙伴</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            align="center"
            style="padding-bottom: 10px;margin-top: 30px; color:#666666"
            class="footow"
          >
            <a
              href="http://www.bioflin.com/#/help/9"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >公司简介</a> | &nbsp;
            <a
              href="http://www.bioflin.com/#/help/9"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >关于我们</a> | &nbsp;
            <a
              href="http://www.bioflin.com/#/help/11"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >联系我们</a> | &nbsp;
            <a href="https://www.bioflin.com:83/qr_code.html" class="link" target="_blank">联系客服</a>| &nbsp;
            <a href="https://www.bioflin.com/#/help" class="link" target="_blank">帮助中心</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/help/6_4"
              class="link"
              target="_blank"
            >售后服务</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/help/3_1"
              class="link"
              target="_blank"
            >配送与验收</a>| &nbsp;
            <a href="https://www.bioflin.com/#/help/10" class="link" target="_blank">隐私政策</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/join"
              class="link"
              target="_blank"
            >企业采购</a>
            | &nbsp;
            <a
              href="http://russian.chromatography-resin.com/"
              class="link"
              target="_blank"
            >PreventionProduct</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/results?topClass=%E8%AF%95%E5%89%82%2F%E7%94%9F%E5%8C%96%2F%E5%88%86%E5%AD%90%2F%E7%BB%86%E8%83%9E"
              class="link"
              target="_blank"
            >搜索推荐</a>
          </div>
           <div align="center" style="font-szie:12px;padding-bottom: 10px;">
            二类医疗器械证书号：沪徐食药监械经营备20200004号 ，
            互联网药品服务资格证书号：(沪)-经营性-2020-0018
          </div>
          <div
            align="center"
            style="font-szie:12px;color:#999999;padding-bottom: 10px;"
          >Copyright &copy; 业立生物科技（上海）股份有限公司 丨 沪ICP备12011495号-3 丨  <a target="_Blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402007073" style="color:#999999">沪公网安备 31010402007073号</a></div>
          <div class="alter clearfix">
            <a href="http://www.cyberpolice.cn/wfjb/ " target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/police.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a href="http://www.12377.cn/" target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/report.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a href="http://www.12377.cn/node_548446.htm " target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/report_app.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a
              href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020160818151512000001155629-SAIC_SHOW_310000-20171020200302788590&signData=MEUCIQC18ZuY5R7k6EKoSZONWIxq15nnRFY2U9GQhqlcSH5BkQIgTPPsVB23gtMlJL8zKAD7wzK74O87Ju7mDJBnuNlE9ms="
              target="_Blank"
            >
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/gs.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bioTopBar from "../../components/bioTopBar.vue";
export default {
  components: { bioTopBar },
  data() {
    return {
      serve: this.$store.state.serve,

      rightId: 0,
      qr: false,
      src: "",
      words: "",
      carts: [],
      total: 0,
      count: 0,
      cart_show: true,
      keywords: "",
      islogin: false,
      footer: ""
    };
  },
  created() {
    this.axios
      .get(this.serve + "/isLogin", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.data == "1") {
          // console.log(1)
          this.loadCart();
          this.islogin = true;
          this.$store.state.islogin = true;
        }
      });

    this.axios.get(this.serve + "/wxgzh_img").then(res => {
      this.src = res.data.data;
    });

    this.axios.get(this.serve + "/get_foot_brand").then(res => {
      this.footer = res.data;
    });
  },
  watch: {
    "$store.state.cart_show": {
      handler: function(newer, older) {
        this.cart_show = newer;
      },
      deep: true
    },
    "$store.state.cart_count": {
      handler: function(newer, older) {
        this.count = newer;
      },
      deep: true
    },
    $route(v) {
      var that = this;
      this.axios
        .get(this.serve + "/member/get_car_three", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.results && res.data.results.length > 0) {
            that.count = res.data.count;
            that.$store.commit("set", res.data.count);
          }
        });
    }
  },
  methods: {
    search() {
      if (this.keywords != "") {
        this.$router.push({
          path: "/results",
          query: { keywords: this.keywords }
        });
      }
    },
    delItem(id) {
      var that = this;
      this.axios
        .get(this.serve + "//member/del_car", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          that.loadCart();
        });
    },
    loadCart() {
      var that = this;
      this.axios
        .get(this.serve + "//member/get_car_three", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          that.carts = [];
          that.count = 0;
          that.total = 0;
          if (res.data.results && res.data.results.length > 0) {
            that.carts = res.data.results;
            that.count = res.data.count;
            that.total = res.data.money;
            that.$store.commit("set", res.data.count);
          }
        });
    },
    clearCart() {
      this.carts = [];
    },
    goCart() {
      this.$router.push("/user/cart");
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.tel {
  line-height: 30px;
  margin-left: 10px;
}
.t1 {
  color: #666;
  svg {
    margin-right: 5px;
  }
}
body {
  font-size: 14px;
  font-family: "微软雅黑";
}
.page-t {
  font-size: 17px;
  color: #999;
  padding: 30px 0;
}

#userTpl {
  .onHover {
    background-color: #e2211c;
    color: #fff;
  }

  .qr {
    img {
      height: 100px;
      width: 100px;
    }
  }
  .brands:hover {
    color: #e2211c;
    text-decoration: underline;
  }
  .img1 {
    position: relative;
    top: 20px;
    margin-right: 10px;
  }
  .link {
    color: #808080;
    text-decoration: none;
    margin-right: 10px;
  }
  #footer {
    position: relative;
    .soild {
      width: 100%;
      height: 1px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      top: 346px;
      left: 0;
    }
    .soild1 {
      width: 100%;
      height: 1px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      left: 0;
      bottom: 130px;
    }
    padding: 30px 0 0 0;
    .footow > a:hover {
      color: #e2211c;
    }
    .title {
      text-align: center;
      font-size: 19px;
      color: #999;
      margin-bottom: 20px;
    }

    .info {
      text-align: center;
      .brand {
        text-decoration: none;
        color: #999;
      }
      .brand:hover {
        color: #e2211c;
      }
      .brand.hvr-fade {
        display: inline;
      }
    }
    .phone {
      text-align: center;
      .ico {
        font-size: 20px;
        margin-right: 20px;
      }
      .number {
        font-size: 17px;
        font-weight: bold;
      }
    }
    .box {
      border: 1px solid #e8e8e8;
      height: 86px;
      width: 86px;
      margin: 0 auto;
      .ico {
        text-align: center;
        padding: 20px 0 10px 0;
        font-size: 25px;
      }
      .label {
        text-align: center;
        font-size: 12px;
      }
    }
    .box:hover {
      color: #e2211c;
      border: 1px solid #e2211c;
      cursor: pointer;
    }
    .hvr-fade {
      background-color: transparent;
    }
    .footer2 {
      .top {
        padding: 10px 0;
        line-height: 80px;
        // display: flex;
        // justify-content: space-between;
        > div {
          float: left;
          margin-right: 70px;
          padding-left: 70px;
        }
      }
      .link1 {
        .list {
          color: #333333;
          // display: flex;
          // justify-content: space-between;
          > div {
            float: left;
            padding-left: 90px;
            margin-right: 80px;
          }
          h3 {
            font-size: 16px;
            font-family: "MicrosoftYaHei";
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
          ul {
            padding: 0;
          }
          li {
            line-height: 30px;
            list-style: none;
            text-align: left;
          }
          li > a:hover {
            color: #e2211c;
          }
        }
      }
      .alter {
        width: 500px;
        margin: 0 auto;
        padding-bottom: 20px;
        > a {
          // display: inline-block;
          // *display: inline;
          // *zoom: 1;
          float: left;
        }
      }
    }
  }
}
</style>